import { useDictionary } from '@/contexts/DictionaryContext'
import { useCallback } from 'react'
import type { IDocumentListItem } from '@/types/document'

export default function useDocumentsDictionary() {
  const { getDictionary } = useDictionary()

  const getDocuments = useCallback(() => {
    return getDictionary('documents') as IDocumentListItem[] | undefined
  }, [getDictionary])

  return {
    getDocuments,
  }
}
